<template>
    <div class="row">
        <div class="col-md-12 text-right">
            <button style="margin-top: -42px" class="btn btn bg-gradient-warning" v-on:click="print()">Print</button>
        </div>
        <div class="col-12" v-for="(c, chapInd) in lessonPlan">
            <div :id="'card-' + c.key" class="card collapsed-card card-custom-outline shadow">
                <div class="card-header">
                    <h3 class="card-title"><strong>{{c.Chapter}}</strong></h3>
                    <div class="card-tools">
                        <span title="3 " :class="'badge' + (c.Progress == 0 ? ' bg-danger' : ' bg-success')">{{c.Progress.toFixed(0)}}% Completed</span>
                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                            <i class="fas fa-plus"></i>
                        </button>
                    </div>
                </div>

                <div :id="'body-' + c.key" class="card-body" style="display: none;">
                    <div class="row">
                        <div class="col-lg-6 col-md-12 col-sm-12" v-for="(t, i) in c.Topics">
                            <h6 class="topic">
                                <strong>Topic {{i + 1}}: {{t.Topic}}</strong>
                                <span title="3 " :class="'badge' + (t.Progress == 0 ? ' bg-danger' : ' bg-success')" style="font-size: 11px">{{t.Progress.toFixed(0)}}% Completed</span>
                                <!--<button class="btn float-right btn-xs bg-gradient-navy">Progress</button>-->
                            </h6>

                            <dl class="row">
                                <dt class="col-lg-3 col-md-4 col-sm-4">Duration Required</dt>
                                <dd class="col-lg-9 col-md-8 col-sm-8">{{t.CompletionTime}} minutes</dd>
                                <dt class="col-lg-3 col-md-4 col-sm-4">Description</dt>
                                <dd class="col-lg-9 col-md-8 col-sm-8">{{t.Description}} <span v-if="!t.Description">-</span></dd>
                                <dt class="col-lg-3 col-md-4 col-sm-4">Objectives</dt>
                                <dd class="col-lg-9 col-md-8 col-sm-8">
                                    <ul>
                                        <li v-for="o in t.Objectives">{{o}}</li>
                                    </ul>
                                    <span v-if="t.Objectives.length == 0">-</span>
                                </dd>
                                <dt class="col-lg-3 col-md-4 col-sm-4">Outcomes</dt>
                                <dd class="col-lg-9 col-md-8 col-sm-8">
                                    <ul>
                                        <li v-for="o in t.Outcomes">{{o}}</li>
                                    </ul>
                                    <span v-if="t.Outcomes.length == 0">-</span>
                                </dd>
                                <!--<dt class="col-lg-3 col-md-4 col-sm-4">Practice Ques.</dt>
        <dd class="col-lg-9 col-md-8 col-sm-8">
            <ul>
                <li v-for="o in t.PracticeQuestions">{{o}}</li>
            </ul>
            <span v-if="t.PracticeQuestions.length == 0">-</span>
        </dd>
        <dt class="col-lg-3 col-md-4 col-sm-4">Reinforce. Ques.</dt>
        <dd class="col-lg-9 col-md-8 col-sm-8">
            <ul>
                <li v-for="o in t.ReinforcementQuestions">{{o}}</li>
            </ul>
            <span v-if="t.ReinforcementQuestions.length == 0">-</span>
        </dd>-->
                                <dt class="col-lg-3 col-md-4 col-sm-4">Activities</dt>
                                <dd class="col-lg-9 col-md-8 col-sm-8">
                                    <ul>
                                        <li v-for="o in t.Activities"><b>{{o.Category}}:</b> {{o.Activity}}</li>
                                    </ul>
                                    <span v-if="t.Activities.length == 0">-</span>
                                </dd>
                            </dl>

                            <hr>
                        </div>
                    </div>
                </div>
            </div>

        </div>

         
    </div>
</template>

<script>const axios = require('axios').default;
 
    export default ({

        data() {
            return {
                teacherID: 0,
                lessonPlan: [],
                topic: { Topic: '', CoursePlanID: 0, ProgressHistory: [] },
                progress: 50,
                date: '',
                topicInd: -1,
                chapInd: -1,
            }
        },

        created: function () {
            this.pageLoad();
        },

        methods: {

            pageLoad: function () {
                const urlParams = new URLSearchParams(window.location.search);

                if (urlParams) {
                    this.teacherID = Number(urlParams.get('teacherID'));

                    var uri = window.location.toString();
                    if (uri.indexOf("?") > 0) {
                        var clean_uri = uri.substring(0, uri.indexOf("?"));
                        window.history.replaceState({}, document.title, clean_uri);
                    }
                }
                if (!this.teacherID || this.teacherID == 0)
                    window.location.href = '../Home/Index';

                startReq();
                var vm = this;
                axios.post('/api/PortalApi/pageLoadLessonPlan?teacherID=' + vm.teacherID)
                    .then(function (res) {
                        endReq();
                        if (res.data.status) {
                            vm.lessonPlan = res.data.lessonPlan;
                            vm.date = res.data.date;

                            var pending = vm.lessonPlan.find(x => x.Pending);
                            if (pending) {
                                console.log($('#body-' + pending.key));
                                console.log($('#card-' + pending.key));
                                $('#card-' + pending.key).removeClass("collapsed-card");
                                $('#body-' + pending.key).removeAttr("style");
                            }
                        }
                        else {
                            toastr.error(res.data.msg);
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
              
            save() {
                if (!this.date) {
                    toastr.error("Date is required");
                    return;
                }

                startReq();
                var vm = this;
                axios.post('/api/PortalApi/saveTeacherProgress?teacherID=' + vm.teacherID + "&date=" + vm.date + "&planID=" + vm.topic.CoursePlanID + "&prog=" + vm.progress)
                    .then(function (res) {
                        endReq();
                        if (res.data.status) {
                            toastr.success("Saved Successfully", "Done!");
                            vm.progress = '';
                            $('#mdlProgress').modal('hide');
                            vm.lessonPlan[vm.chapInd].Progress = res.data.progress.Progress;
                            vm.lessonPlan[vm.chapInd].Topics[vm.topicInd].Progress = res.data.progress.TopicProgress;
                            vm.lessonPlan[vm.chapInd].Topics[vm.topicInd].ProgressHistory = res.data.progress.ProgressHistory;

                            vm.chapInd = -1;
                            vm.topicInd = -1;
                        }
                        else
                            toastr.error(res.data.msg);
                    })
            },

             
            print() {
                window.open('../Portal/LessonPlanPrint?teacherID=' + this.teacherID);
            }

        }
    })</script>

<style scoped>
    ul, ol {
        padding-left: 13px;
        margin-bottom: 0px;
    }

    .text-sm .btn {
        font-size: 12px !important;
    }

    .topic {
        border-bottom: 1px dashed black;
        padding-bottom: 8px;
    }
</style>


// WEBPACK FOOTER //
// src/components/school/lessonPlan/lessonPlan.vue